class SubpageMenu {

    subpageMenu;
    selectedItem;

    constructor() {
        this.subpageMenu = document.getElementById('subpage-menu');

        if (!this.subpageMenu) {
            return;
        }

        this.selectedItem = this.subpageMenu.querySelector('ul .selected');

        this.subpageMenu.addEventListener('click', () => this.onMenuClick());

        this.selectedItem.firstElementChild.addEventListener('focus', () => {
            this.expandMenu();
        });

        // Align the selected item on init
        this.selectedItem.classList.add('preload');
        this.alignSelectedItem();
        afterNextDomRepaint().then(() => {
            this.selectedItem.classList.remove('preload');
        });
    }

    expandMenu() {
        this.subpageMenu.classList.add('open');
        this.selectedItem.style.transform = 'unset';
        this.subpageMenu.querySelector('.burger-container').setAttribute('title', 'Luk undermenu');
    }

    alignSelectedItem() {
        this.selectedItem.style.transform = `translateY(${this.selectedItem.offsetTop * -1}px)`;
    }

    onMenuClick() {
        if (this.subpageMenu.classList.contains('open')) {
            this.subpageMenu.classList.remove('open');
            this.alignSelectedItem();
            this.subpageMenu.querySelector('.burger-container').setAttribute('title', 'Åben undermenu');
        } else {
            this.expandMenu();
        }
    }
}

window.addEventListener('load', () => {
    new SubpageMenu();
});